var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./pipelines_artifacts.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-713a66cf\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./pipelines_artifacts.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./pipelines/components/pipelines_artifacts.vue
// module id = ./pipelines/components/pipelines_artifacts.vue
// module chunks = commit_pipelines pipelines